// Phase 11d — caregiver-self earnings rollup (`/me/caregiver/earnings`).
//
// Per 11d-6: minimal GROUP BY year of confirmed payouts. No params, no
// per-month breakdown, no aggregate total across years, no isYearToDate
// flag — the frontend derives all that.
//
// Per 11d-6a: attribution by `issuedAt` year (T4A-aligned).
// Per 11d-6b: ISSUED + PAID payouts only (VOIDED excluded).
// Per 11d-6c: single response with all years.
import { z } from 'zod';
export const CaregiverEarningsYearSchema = z.object({
    year: z.number().int().min(2000).max(2200),
    subtotalCents: z.number().int().min(0),
    hstCents: z.number().int().min(0),
    totalCents: z.number().int().min(0),
});
export const CaregiverEarningsSelfResponseSchema = z.object({
    years: z.array(CaregiverEarningsYearSchema),
});
//# sourceMappingURL=earnings-self.schema.js.map